export default __webpack_public_path__ + "locales/zh-CN/InfoPanel.json?hash=8b2a8175d56e7692cfe9a02fc7077ea2";